import { LOADING_DEFAULT } from '../../copy';

/**
 * Something is on its way.
 *
 * `role="status"` so a screen reader announces it without stealing focus, and a
 * label that is always present rather than a bare spinner -- a spinning shape
 * with no text says nothing to anyone who cannot see it.
 */
export function LoadingState({
  label = LOADING_DEFAULT,
  compact = false,
  announce = true,
}: {
  label?: string;
  compact?: boolean;
  /**
   * Whether assistive technology should be told about this. Off only for the
   * samples in the shell's showcase: a demonstration of a loading state is not
   * a loading state, and announcing three of them on every page load would be
   * noise for the people who rely on it most.
   */
  announce?: boolean;
}) {
  return (
    <div
      className={compact ? 'state state--compact' : 'state'}
      {...(announce ? { role: 'status', 'aria-live': 'polite' as const } : {})}
    >
      <span className="state__spinner" aria-hidden="true" />
      <p className="state__message">{label}</p>
    </div>
  );
}
